export const BULAN = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const rp = (v) => {
  const n = Math.round(Number(v) || 0);
  const s = Math.abs(n).toLocaleString("id-ID");
  return n < 0 ? `-Rp ${s}` : `Rp ${s}`;
};

export const parseISO = (s) => {
  const [y, m, d] = s.slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const toISO = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const todayISO = () => toISO(new Date());
export const addDays = (iso, n) => {
  const d = parseISO(iso);
  d.setDate(d.getDate() + n);
  return toISO(d);
};

export const tglID = (s) => {
  if (!s) return "-";
  const d = parseISO(s);
  return `${d.getDate()} ${BULAN[d.getMonth()]} ${d.getFullYear()}`;
};

export const dEN = (s) => {
  if (!s) return "-";
  const d = parseISO(s);
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
};

export const TRIP_TYPES = ["Fun Dive", "Try Scuba", "Snorkeling", "Course", "Liveaboard 3N", "Liveaboard 4N", "Liveaboard 5N", "Other"];

export const BOOKING_STATUS = {
  upcoming: { label: "Upcoming", cls: "bg-sky-100 text-sky-800" },
  completed: { label: "Completed", cls: "bg-emerald-100 text-emerald-800" },
  cancelled: { label: "Cancelled", cls: "bg-slate-200 text-slate-600" },
};

export const PAY_STATUS = {
  unpaid: { label: "Unpaid", cls: "bg-rose-100 text-rose-800" },
  deposit: { label: "Deposit", cls: "bg-amber-100 text-amber-800" },
  paid: { label: "Paid in full", cls: "bg-emerald-100 text-emerald-800" },
};

export const INVOICE_STATUS = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700" },
  sent: { label: "Sent", cls: "bg-sky-100 text-sky-800" },
  paid: { label: "Paid", cls: "bg-emerald-100 text-emerald-800" },
};
